import React from 'react';
import AppLayout from '../components/app/AppLayout';
import AnalyticsPlaceholder from '../components/app/AnalyticsPlaceholder';

function AnalyticsPage() {
  return (
    <AppLayout>
      <AnalyticsPlaceholder />
    </AppLayout>
  );
}

export default AnalyticsPage;








